import { lineHeightNone, lineHeightShort, lineHeightBase, fontFamilyMain, fontSizeXs, fontSizeSm, fontSizeMd, fontSizeLg, fontSizeXl, fontSize2xl, fontSize3xl, fontSize4xl, fontSize5xl, } from "@airhelp/design-tokens";
const typography = {
    lineHeights: {
        none: lineHeightNone,
        short: lineHeightShort,
        shorter: lineHeightShort,
        base: lineHeightBase,
    },
    fonts: {
        body: fontFamilyMain,
        heading: fontFamilyMain,
    },
    fontSizes: {
        xs: fontSizeXs,
        sm: fontSizeSm,
        md: fontSizeMd,
        lg: fontSizeLg,
        xl: fontSizeXl,
        "2xl": fontSize2xl,
        "3xl": fontSize3xl,
        "4xl": fontSize4xl,
        "5xl": fontSize5xl,
    },
};
export default typography;
